// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SL3yo","name":"styles_name__1350m","phone":"styles_phone__3WYvx"};